import { defineStore } from 'pinia'
import { ref } from 'vue'

export interface VideoModalOptions {
    src: string
    poster?: string
    title?: string
    autoplay?: boolean
}

export const useVideoModalStore = defineStore('videoModal', () => {
    const visible = ref(false)
    const videoSrc = ref('')
    const poster = ref('')
    const title = ref('')
    const autoplay = ref(true)

    function open(options: VideoModalOptions): void {
        videoSrc.value = options.src
        poster.value = options.poster || ''
        title.value = options.title || ''
        autoplay.value = options.autoplay ?? true
        visible.value = true
    }

    function close(): void {
        visible.value = false
        setTimeout(() => {
            videoSrc.value = ''
            poster.value = ''
            title.value = ''
        }, 300)
    }

    return {
        visible,
        videoSrc,
        poster,
        title,
        autoplay,
        open,
        close
    }
})
